import type { SVGProps } from 'react'

export const TagsMonitorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_19468_1819)">
      <path
        d="M4.88885 7.22224L6.44439 8.7778L9.55546 5.66668M15 15L11.6556 11.6555M13.4443 7.22224C13.4443 10.6587 10.6586 13.4445 7.22216 13.4445C3.78575 13.4445 1 10.6587 1 7.22224C1 3.78579 3.78575 1 7.22216 1C10.6586 1 13.4443 3.78579 13.4443 7.22224Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_19468_1819">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
